/* eslint-disable*/
import {assignDeep, _} from './assignDeep.js';
import {encodeObjectURIComponent} from './tools';
export default (log, trackLog) => new Promise((resolve) => {
    const {refer, platform, page_type, page_type_extend, ...element_param} = trackLog;
    const defaultLog = {
        refer,
        platform,
        page_type,
        extra: {page_type_extend},
        element_param
    };
    const finalParam = encodeObjectURIComponent(assignDeep({}, defaultLog, log));

    let imgEl = new Image();
    imgEl.onload = () => {
        resolve();
        imgEl = null;
    };
    imgEl.onerror = () => {
        resolve();
        imgEl = null;
    };
    imgEl.src = `//luna.58.com/track/v2?${Object.keys(finalParam).map((k) => `${k}=${finalParam[k]}`)
        .join('&')}`;

});
